/**
 * Sætningen, der fortæller medlemmet, at det er logget ind som virksomhed med MitID Erhverv.
 *
 * Står ét sted, fordi forsiden og ID-kort-siden begge siger det, og de to ikke må beskrive
 * sessionen forskelligt (ADV-356). Ordet "virksomheden" er med vilje: en enkeltmandsvirksomhed
 * bærer typisk advokatens eget navn ("Advokat …"), og uden ordet læses "logget ind som
 * Advokat …" som medlemmet selv.
 */
export const firmaLoginTekst = (navn?: string | null): string =>
  `Du er logget ind med MitID Erhverv${navn ? ` for virksomheden ${navn}` : ""}.`;
